import { ThreadsType } from './types'

const useApp = () => {
  const getInitialChatHistoryVisibility = (threads?: ThreadsType) => {
    if (!threads || threads.length === 0) {
      return false
    }

    const hasMoreThanOneThread = threads.length > 1
    const hasOnlyClosedThreads = threads.every(thread => !thread.isOpenThread)
    const shouldShowHistory = hasMoreThanOneThread || hasOnlyClosedThreads

    return shouldShowHistory
  }

  return {
    getInitialChatHistoryVisibility
  }
}

export default useApp
